import { render, staticRenderFns } from "./PrintSort.vue?vue&type=template&id=26997e16&scoped=true&"
import script from "./PrintSort.vue?vue&type=script&lang=ts&"
export * from "./PrintSort.vue?vue&type=script&lang=ts&"
import style0 from "./PrintSort.vue?vue&type=style&index=0&id=26997e16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26997e16",
  null
  
)

export default component.exports